import { useUserStore } from '@/store';
import { mapState as rootMapState } from 'pinia';


import { h, resolveDirective, withDirectives } from "vue";
import signLog, { sendVowEmail } from '@/components/sign-log';

//  show logic : 1.  not logged in  2.  Login unverified email
export default {
    i18next: {
        ns: 'md-house'
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        isLogin() {
            return !!this.user;
        },
        
    },
    render() {
        let rawHTML = this.isLogin ? this.$t('md-house.verifyYourEmail') : this.$t('md-house.registerForPrice');

        let click = resolveDirective('click');
        return withDirectives(h('p', {
            class: 'hide-price title-mask',
            innerHTML: rawHTML
        }), [
            [click, {
                selector: '.link',
                callback: this.isLogin ? this.toVerify : this.register,
                modifier: {
                    prevent: true,
                    stop: true
                }
            }]
        ])
    },
    methods: {
        register() {
            signLog.register({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ => this.$t('byContinuingYouAgree')
                },
                onregister: (user, inquiry) => {
                    return false;
                },
                onsuccess: () => {
                    return false; //  Do not pop up the default prompt box
                }
            });
        },
        toVerify() {
            sendVowEmail({ user: this.user, isResend: true });
        }
    }
};
